// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1K-Wa","selects":"Documents_selects__1vvsA"};